import { ActionTree } from 'vuex';
import { ICreateDirectoryState } from './create-directory.types';
import {
  ECreateDirectoryAction,
  ECreateDirectoryMutation,
  state as defaultState,
} from './create-directory.constants';
import { RootState } from '@/store/store';
import { IDirectory } from '@/api/directories/types/directory';
import { DirectoryService } from '@/api/directories/services/directory.service';
import { translate } from '@/helpers/translation.helper';
import { alertNamespace, EAlertAction } from '@/alert/store/alert.constants';

export const actions: ActionTree<ICreateDirectoryState, RootState> = {
  async [ECreateDirectoryAction.Create](
    { dispatch, commit },
    { title, directory }: { title: string; directory: string }
  ) {
    commit(ECreateDirectoryMutation.SetCreating, true);
    try {
      const newDirectory: IDirectory = await DirectoryService.create({ title, directory });
      dispatch(ECreateDirectoryAction.CreateSuccess, newDirectory);
    } catch (e) {
      dispatch(ECreateDirectoryAction.CreateFailed);
    }
  },
  [ECreateDirectoryAction.CreateSuccess]({ dispatch, commit }, createdDirectory: IDirectory) {
    commit(ECreateDirectoryMutation.SetCreatedDirectory, createdDirectory);
    commit(ECreateDirectoryMutation.SetCreating, false);
    dispatch(
      `${alertNamespace}/${EAlertAction.ShowSuccess}`,
      `${translate('created-folder')} ${createdDirectory.title}`,
      {
        root: true,
      }
    );
  },
  [ECreateDirectoryAction.CreateFailed]({ dispatch, commit }) {
    commit(ECreateDirectoryMutation.SetCreating, false);
    commit(ECreateDirectoryMutation.SetCreatedDirectory, { ...defaultState }.createdDirectory);
    dispatch(`${alertNamespace}/${EAlertAction.ShowDanger}`, translate('could-not-create-folder'), {
      root: true,
    });
  },
  [ECreateDirectoryAction.UpdateDirectoryPath]({ commit }, path: string) {
    commit(ECreateDirectoryMutation.SetDirectoryPath, path);
  },
  [ECreateDirectoryAction.UpdateDirectoryNames]({ commit }, directories: IDirectory[]) {
    const names: string[] = directories.map((directory: IDirectory): string => directory.title);
    commit(ECreateDirectoryMutation.SetDirectoryNames, names);
  },
  [ECreateDirectoryAction.Reset]({ commit }) {
    commit(ECreateDirectoryMutation.SetState, { ...defaultState });
  },
};
